class ProductLowStock extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initial_availability = "true" === this.dataset.initialAvailability;
        this.initial_quantity = parseInt(this.dataset.initialQuantity);
        this.threshold = parseInt(this.dataset.threshold);
        this.variants_json = JSON.parse(this.querySelector("#product-low-stock--json").innerHTML);
        this.updateListener();
        this.initial_availability ? this.update(this.initial_quantity) : this.show(false);
    }

    updateListener() {
        window.on(`theme:product:${this.dataset.id}:variantChanged`, ({ detail: { variant: i } }) => {
            const t = this.variants_json.find(t => t.id === i.id);
            this.update(t ? t.quantity : 0);
        });
    }

    update(t) {
        if (t > 20) {
            this.innerText = "In Stock";
            this.show(true);
        } else if (!t || t < 1 || t > this.threshold) {
            // If quantity is not within the desired range or is empty, hide the element
            this.show(false);
        } else {
            let i;
            if (t === 1) {
                i = theme.translations.low_in_stock.one;
            } else {
                i = theme.translations.low_in_stock.other.replace(/\d+/, t);
            }
            i = i.replace("&#39;", "'");
            this.innerText = i;
            this.show(true); // Show the element
        }
    }

    show(isVisible) {
        this.style.display = isVisible ? "block" : "none";
        this.parentNode.setAttribute("data-empty", !isVisible);
    }
}

const productLowStockEl = customElements.get("product-low-stock-root");
productLowStockEl || customElements.define("product-low-stock-root", ProductLowStock);
